import LeftImageContentBlock from './LeftImageContentBlock'

export default LeftImageContentBlock
